import { useState } from "react";
import ExploreItemModal from "./ExploreItemModal";

function getPdfUrls(url) {
  let embedUrl = null;
  let downloadUrl = null;

  const driveMatch = url.match(/drive\.google\.com\/file\/d\/([^/]+)/);
  if (driveMatch) {
    const fileId = driveMatch[1];
    embedUrl = `https://drive.google.com/file/d/${fileId}/preview`;
    downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
  } else if (url.includes("docs.google.com")) {
    embedUrl = url.replace(/\/edit.*$/, "/preview");
    downloadUrl = url.replace(/\/edit.*$/, "/export?format=pdf");
  } else if (url.includes("dropbox.com")) {
    embedUrl = url.replace("?dl=0", "?raw=1");
    downloadUrl = url.replace("?dl=0", "?dl=1");
  } else if (url.endsWith(".pdf")) {
    embedUrl = url;
    downloadUrl = url;
  }

  return { embedUrl, downloadUrl };
}

export default function NotesDisplay({
  items,
  handleMarkAsDone,
  markedItems,
  progressKeyPrefix = "noteItem",
  emptyMessage = "No documents available for the selected options.",
  urlField = "url",
  descriptionField = "description",
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalUrl, setModalUrl] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalDownloadUrl, setModalDownloadUrl] = useState("");
  const [isHovered, setIsHovered] = useState(-1);

  return (
    <div>
      {!items ? (
        <div className="d-flex flex-column align-items-center pt-5">
          <h4 className="mb-3 text-center text-secondary">
            Please select options from the left panel and click Search to load
            any notes if available.
          </h4>
        </div>
      ) : (
        <div className="d-flex flex-column">
          {items.length === 0 && (
            <h5 className="mb-3 text-start text-secondary">{emptyMessage}</h5>
          )}
          {items.map((item, idx) => {
            const noteUrl = item[urlField];
            if (!noteUrl) return null;
            const description = item[descriptionField] || "";
            const progressKey = `${progressKeyPrefix}:${item.id}`;
            const { embedUrl, downloadUrl } = getPdfUrls(noteUrl);
            const checked = markedItems && markedItems.includes(progressKey);

            return (
              <div key={item.id} style={{ width: "100%", marginBottom: "12px" }}>
                {embedUrl ? (
                  <div
                    onClick={() => {
                      setModalUrl(embedUrl);
                      setModalDownloadUrl(downloadUrl);
                      setModalTitle(description);
                      setModalOpen(true);
                    }}
                    onMouseEnter={() => setIsHovered(idx)}
                    onMouseLeave={() => setIsHovered(-1)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px 16px",
                      borderRadius: "12px",
                      background:
                        isHovered === idx
                          ? "linear-gradient(135deg, #f5f9ff, #edf6ff)"
                          : "#ffffff",
                      border: "1px solid #eef2f5",
                      boxShadow:
                        isHovered === idx
                          ? "0 8px 20px rgba(52,152,219,0.15)"
                          : "0 2px 6px rgba(0,0,0,0.05)",
                      cursor: "pointer",
                      transition: "all 0.25s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "10px",
                          background: "rgba(231,76,60,0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="fa-solid fa-file-pdf"
                          style={{
                            color: "#e74c3c",
                            fontSize: "0.9rem",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          fontSize: "0.95rem",
                          fontWeight: "600",
                          color: "#2c3e50",
                        }}
                      >
                        {description}
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          const link = document.createElement("a");
                          link.href = downloadUrl || embedUrl;
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        style={{
                          border: "none",
                          background: "none",
                          color: "#fff",
                          padding: "6px",
                          borderRadius: "6px",
                          fontSize: "0.75rem",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        <i
                          className={"fa-solid fa-download"}
                          style={{
                            fontSize: "1rem",
                            color: "black",
                          }}
                        />
                      </button>
                    </div>

                    {handleMarkAsDone && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMarkAsDone(progressKey, !checked);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          cursor: "pointer",
                          padding: "4px 8px",
                          borderRadius: "6px",
                          background: checked ? "#d4edda" : "#f8f9fa",
                          border: `1px solid ${checked ? "#c3e6cb" : "#dee2e6"}`,
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = checked
                            ? "#c3e6cb"
                            : "#e9ecef";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = checked
                            ? "#d4edda"
                            : "#f8f9fa";
                        }}
                      >
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            borderRadius: "3px",
                            border: `2px solid ${checked ? "#28a745" : "#6c757d"}`,
                            background: checked ? "#28a745" : "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {checked && (
                            <i
                              className="fa-solid fa-check"
                              style={{
                                color: "white",
                                fontSize: "10px",
                              }}
                            />
                          )}
                        </div>
                        <span
                          style={{
                            fontSize: "0.8rem",
                            fontWeight: "500",
                            color: checked ? "#155724" : "#495057",
                          }}
                        >
                          {checked ? "Completed" : "Mark Complete"}
                        </span>
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ color: "red" }}>Invalid PDF URL: {noteUrl}</div>
                )}

                {modalOpen && (
                  <ExploreItemModal
                    onClose={() => setModalOpen(false)}
                    isVideo={false}
                    url={modalUrl}
                    title={modalTitle}
                    isDownloadable={true}
                    downloadUrl={modalDownloadUrl}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
